import { ClassCast } from '@utilities/object-helper';
import { ScanFilters } from './scan-filters';
import { WorkOrderFilters } from './work-order-filters';

export class ScanAndWorkOrderFilters {
    @ClassCast(ScanFilters)
    scanFilters: ScanFilters;
    @ClassCast(WorkOrderFilters)
    workOrderFilters: WorkOrderFilters;
}
